import type { LayoutWidget } from '../../redux/config/layout';
import type { LayoutWeight } from '../../redux/slices/new-tab-order';
import type { StagedWidgetDimensions } from '../../redux/slices/update-width-height-of-chart';

export function getWidgetLayoutIds(children: HTMLCollection): Array<Partial<LayoutWidget>> {
  const widgetIds: Array<Partial<LayoutWidget>> = [];
  for (let i = 0, length = children.length; i < length; i++) {
    const element = children[i] as HTMLElement;
    const dataId = element?.getAttribute('data-id');

    if (dataId) {
      widgetIds.push({
        position: i,
        id: dataId,
      });
    }
  }

  return widgetIds;
}

export function updateDataPosition(children: HTMLCollection) {
  for (let i = 0, length = children.length; i < length; i++) {
    const element = children[i] as HTMLElement;
    element.setAttribute('data-position', String(i));
  }
}

export function getLayoutsNewPosition(children: HTMLCollection): Array<LayoutWeight> {
  const widgetIds: Array<LayoutWeight> = [];
  let publicLayoutCounter = 0;
  let privateLayoutCounter = 0;
  for (let i = 0, length = children.length; i < length; i++) {
    const element = children[i] as HTMLElement;
    const title = element.getElementsByClassName(`tabTitle`)[0];
    if (title) {
      const dataId = title.getAttribute('data-id');
      const isPublic = title.classList.contains('publicLayout');

      if (dataId) {
        widgetIds.push({
          weight: isPublic ? ++publicLayoutCounter : ++privateLayoutCounter,
          id: dataId,
        });
      }
    }
  }

  return widgetIds;
}

export function getRenderableLayoutWidgets(
  layoutWidgets: LayoutWidget[],
  activeTabWidgets: LayoutWidget[],
  currentLayoutId: string,
  activeTabId: string | undefined,
  stagedWidgetDimensions: Record<string, StagedWidgetDimensions>
): LayoutWidget[] {
  const currentLayoutWidgetIds = new Set(layoutWidgets.map((widget) => widget.id));
  const hasCurrentLayoutWidgets = activeTabWidgets.some((widget) => currentLayoutWidgetIds.has(widget.id));
  const sourceWidgets = currentLayoutId === activeTabId && hasCurrentLayoutWidgets ? activeTabWidgets : layoutWidgets;

  return sourceWidgets.map((widget) => {
    const stagedDimensions = stagedWidgetDimensions[widget.id];
    if (!stagedDimensions) {
      return widget;
    }

    return {
      ...widget,
      ...stagedDimensions,
    };
  });
}
